import React, { useEffect, useState } from 'react';
import { Input } from './ui/input';

// Competitive result: pick Team A (2 players), enter up to 3 sets (games 0–7).
// Reports { valid, winner_ids, sets } — sets oriented from the winners' view.
export const CompetitiveResultForm = ({ players, de, onChange }) => {
  const [teamA, setTeamA] = useState([]);
  const [sets, setSets] = useState([['', ''], ['', ''], ['', '']]);

  const teamB = players.filter(p => !teamA.includes(p.id)).map(p => p.id);
  const filled = sets.filter(([a, b]) => a !== '' && b !== '').map(([a, b]) => [Number(a), Number(b)]);
  const badSet = filled.some(([a, b]) => a === b || a < 0 || b < 0 || a > 7 || b > 7 || !Number.isInteger(a) || !Number.isInteger(b));
  const winsA = filled.filter(([a, b]) => a > b).length;
  const winsB = filled.filter(([a, b]) => b > a).length;
  const valid = teamA.length === 2 && filled.length > 0 && !badSet && winsA !== winsB;
  const aWon = winsA > winsB;

  useEffect(() => {
    onChange(valid
      ? { valid, winner_ids: aWon ? teamA : teamB, sets: filled.map(([a, b]) => (aWon ? [a, b] : [b, a])) }
      : { valid: false });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(teamA), JSON.stringify(sets)]);

  const toggle = (id) => setTeamA(cur => cur.includes(id) ? cur.filter(x => x !== id) : cur.length < 2 ? [...cur, id] : cur);
  const name = (id) => players.find(p => p.id === id)?.name?.split(' ')[0] || '';
  const setVal = (i, j, v) => setSets(cur => cur.map((r, k) => (k === i ? r.map((x, m) => (m === j ? v.replace(/[^0-9]/g, '').slice(0, 1) : x)) : r)));

  return (
    <div className="space-y-4" data-testid="competitive-result-form">
      <div>
        <p className="text-xs font-semibold text-slate-600 mb-2">{de ? '1. Wer hat zusammen gespielt? Wähle Team A (2 Spieler)' : '1. Who played together? Pick Team A (2 players)'}</p>
        <div className="grid grid-cols-2 gap-2">
          {players.map(p => {
            const inA = teamA.includes(p.id);
            return (
              <button key={p.id} type="button" onClick={() => toggle(p.id)} data-testid={`team-a-toggle-${p.id}`}
                className={`px-3 py-2 rounded-lg border text-sm text-left truncate transition-colors ${inA ? 'border-sky-500 bg-sky-50 text-sky-900 font-semibold' : teamA.length === 2 ? 'border-rose-200 bg-rose-50/50 text-rose-900' : 'border-slate-200 bg-white text-slate-700'}`}>
                <span className="text-[10px] font-bold mr-1.5">{inA ? 'A' : teamA.length === 2 ? 'B' : '·'}</span>{p.name}
              </button>
            );
          })}
        </div>
      </div>
      {teamA.length === 2 && (
        <div>
          <p className="text-xs font-semibold text-slate-600 mb-2">{de ? '2. Satzresultate (Spiele)' : '2. Set scores (games)'}</p>
          <div className="grid grid-cols-[auto_1fr_1fr] gap-x-3 gap-y-2 items-center text-sm">
            <span />
            <span className="text-[11px] font-bold text-sky-700 text-center truncate">A: {teamA.map(name).join(' / ')}</span>
            <span className="text-[11px] font-bold text-rose-700 text-center truncate">B: {teamB.map(name).join(' / ')}</span>
            {sets.map((r, i) => (
              <React.Fragment key={i}>
                <span className="text-xs text-slate-500">{de ? 'Satz' : 'Set'} {i + 1}{i === 2 ? (de ? ' (opt.)' : ' (opt.)') : ''}</span>
                {[0, 1].map(j => (
                  <Input key={j} inputMode="numeric" value={r[j]} onChange={e => setVal(i, j, e.target.value)} placeholder="0"
                    className="h-10 text-center text-lg font-bold bg-white" data-testid={`set-${i}-team-${j === 0 ? 'a' : 'b'}`} />
                ))}
              </React.Fragment>
            ))}
          </div>
          <p className={`text-xs mt-2 font-semibold ${valid ? 'text-emerald-700' : 'text-slate-400'}`} data-testid="result-preview">
            {badSet ? (de ? 'Ungültiger Satz (0–7 Spiele, kein Unentschieden)' : 'Invalid set (0–7 games, no tie)')
              : valid ? `${de ? 'Sieger' : 'Winner'}: Team ${aWon ? 'A' : 'B'} · ${filled.map(([a, b]) => `${a}:${b}`).join(' · ')}`
              : (de ? 'Resultat eingeben' : 'Enter the score')}
          </p>
        </div>
      )}
    </div>
  );
};
